module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10021.6ff4225c.jpg";